export const SIDELINED = "Sidelined";
export const SIDELINE = "SIDELINE";
export const ROUTE_CUT = "RouteCut";
export const ASSIGNABLE = "Assignable";
export const IN_PROGRESS = "In Progress";
export const NOT_READY = "Not Ready";
export const STAGED = "Staged";
export const DEPARTED = "Departed";
export const STOWED = "Stowed";
export const PLANNED = "PLANNED";
export const PENDING_STAGE = "Staged (pending)";
export const PENDING_PICK = "Picked (pending)";
export const PARTIALLY_DEPARTED = "Departed (partial)";
export const PARTIALLY_STAGED = "Staged (partial)";
export const PARTIALLY_PICKED = "Picked (partial)";
export const PARTIALLY_STOWED = "Stowed (partial)";
export const ROUTES_AT_RISK = "At risk";
export const DONE = "Done";
export const NOT_STARTED = "Not started";
export const PROGRESSING = "Progressing";
export const STOW_PENDING = "Stow pending";
export const STAGE_PENDING = "Stage pending";
export const STAGE_IN_PROGRESS = "Stage in progress";
export const TOTAL_GROCERY = "Total grocery";
export const TOTAL_ROUTES = "Total routes";
export const TOTAL_CORE = "Total core";
export const PICK_PENDING = "Pick pending";
export const PICK_IN_PROGRESS = "Pick in progress";
export const ASSIGNED = "Assigned";
export const PENDING = "Pending";
export const ACTIVE = "ACTIVE";
export const STOW = "Stow";
export const PICK = "Pick";
export const STAGE = "Stage";

export const WORK_GROUP_TYPES = {
  CORE_PICK: "CORE_PICK",
  GROCERY_PICK: "GROCERY_PICK",
};

export const isDropToCartEnabled = (stationConfig) => {
  return stationConfig && stationConfig.dropToCartEnabled;
};

// Metric keys for status mapping
export const METRIC_KEYS = {
  STOW_PENDING_STATUS: "stowPending",
  STOWED_STATUS: "stowed",
  PICK_PENDING_STATUS: "pickPending",
  PICK_IN_PROGRESS_STATUS: "pickInProgress",
  STAGE_PENDING_STATUS: "stagePending",
  STAGE_IN_PROGRESS_STATUS: "stageInProgress",
  STAGED_STATUS: "staged",
  DONE_STATUS: "done",
  NOT_STARTED_STATUS: "notStarted",
  PROGRESSING_STATUS: "progressing",
  AT_RISK_STATUS: "isAtRisk",
};

// Status to metric key mapping
export const STATUS_TO_METRIC_KEY_MAP = {
  [STOW_PENDING]: METRIC_KEYS.STOW_PENDING_STATUS,
  [STOWED]: METRIC_KEYS.STOWED_STATUS,
  [PICK_PENDING]: METRIC_KEYS.PICK_PENDING_STATUS,
  [PICK_IN_PROGRESS]: METRIC_KEYS.PICK_IN_PROGRESS_STATUS,
  [STAGE_PENDING]: METRIC_KEYS.STAGE_PENDING_STATUS,
  [STAGE_IN_PROGRESS]: METRIC_KEYS.STAGE_IN_PROGRESS_STATUS,
  [STAGED]: METRIC_KEYS.STAGED_STATUS,
  [DONE]: METRIC_KEYS.DONE_STATUS,
  [NOT_STARTED]: METRIC_KEYS.NOT_STARTED_STATUS,
  [PROGRESSING]: METRIC_KEYS.PROGRESSING_STATUS,
  [ROUTES_AT_RISK]: METRIC_KEYS.AT_RISK_STATUS,
};

/**
 * Updates route status to assignable if route is unassigned
 *
 * @param routes
 * @returns updated routes
 */
export function updateUnassignedRouteStatus(routes) {
  routes.forEach((route) => {
    if (route.routeStatus === IN_PROGRESS && !route.activeAssignee) {
      route.routeStatus = ASSIGNABLE;
    }
  });
  return routes;
}
/**
 * Returns route status
 *
 * @param route status returned by RSWS
 * @returns route status
 */
export function getRouteStatus(route) {
  if (route.sidelined) {
    return SIDELINED;
  }
  if (route.routeCut) {
    return ROUTE_CUT;
  }
  // the route status should be "Done" if all the Picklists are Staged for that route
  if (
    route.picklists &&
    route.picklists.every((picklist) => picklist.status === STAGED)
  ) {
    return DONE;
  }
  switch (route.routeStatus) {
    case STAGED:
    case DEPARTED:
    case PARTIALLY_DEPARTED:
      return DONE;
    case IN_PROGRESS:
    case ASSIGNABLE:
    case PARTIALLY_STAGED:
    case ASSIGNED:
      return PROGRESSING;
    case NOT_READY:
      return NOT_STARTED;
    default:
      return route.routeStatus;
  }
}

/**
 * Returns route status indicate color
 *
 * @param Status
 * @returns {string}
 */

export function getPicklistStatusColor(Status) {
  switch (Status) {
    case SIDELINED:
      return "warning";
    case STAGED:
    case DONE:
      return "success";
    case PROGRESSING:
    case STOWED:
    case PICK_PENDING:
    case PICK_IN_PROGRESS:
    case STAGE_PENDING:
    case STAGE_IN_PROGRESS:
      return "theme";
    default:
      return "neutral";
  }
}



// WEBPACK FOOTER //
// ./src/components/RouteStatus/utils/EntityStatusManager.js